import * as React from 'react'

import { Box, Flex } from '~ui/components/layout/Box'

type TContainerProps = OmitSafe<PropsOf<typeof Box>, 'flexGrow'>

type TProps = RequiredChildren &
  TContainerProps & {
    screenBgColor: PropsOf<typeof Flex>['bgColor']
    footer: React.ReactNode
  }

/**
 * Screen wrapper that renders its children inside a layout with speedlo-footer.
 * Provided props will be passed to the inner container (Box) to style the content (children).
 */
export const FooterScreen: React.FC<TProps> = ({
  screenBgColor,
  children,
  footer,
  ...containerProps
}) => {
  return (
    <>
      <Flex
        bgColor={screenBgColor}
        flexDirection={`column`}
        minHeight={`100vh`}
        isolation={`isolate`}
        position={`relative`}
        zIndex={2}
      >
        <Box {...containerProps} flexGrow={1}>
          {children}
        </Box>
      </Flex>
      <Box bgColor={`bgColors.card`} isolation={`isolate`} position={`relative`} zIndex={1}>
        {footer}
      </Box>
    </>
  )
}
